import React, { useEffect, useState } from "react";
import { Navbar, Footer, } from "../../components/shared";
import useCheckLoggedin from "../../utils/useCheckLoggedin";
import { useUser } from "../../hooks/useUser";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form"; // Import react-hook-form
import '../general/General.css';
import { useLocation, useNavigate } from 'react-router-dom';
import FamilyDetails from "./FamilyDetails";
import DonationDetails from "./DonationDetails";
import MessagesDetails from "./Messages";
import { Loading, Breadcrumbs } from '../../components/shared';

const UserProfileHome = () => {
  useCheckLoggedin(); // Check if the user is logged in (if no user data, redirect to login)

  const user = useSelector((state) => state.user);  // Accessing the user from Redux store
  const { getUser, updateUser, loading: userLoading, errorMessage, userData } = useUser();
  const [isEditing, setIsEditing] = useState(false); // State to toggle between view and edit mode
  const [showFamilyDetails, setShowFamilyDetails] = useState(false);
  const [showDonations, setShowDonations] = useState(false);
  const [showMessages, setShowMessages] = useState(false);

  const { register, handleSubmit, formState: { errors, isSubmitting }, setValue } = useForm();
  const navigate = useNavigate();


  const location = useLocation();
  // Check mobile verification and redirect if not completed
  useEffect(() => {

    const fromMobileVerification = new URLSearchParams(location.search).get('fromMobileVerification');
    if (userData && userData.user.mobileVerification !== "completed" && !fromMobileVerification) {
      // Redirect to mobile verification page only if the user hasn't come from there already
      navigate(`/user/mobile-verification`);
    }

  }, [userData, navigate]);
  useEffect(() => {
    if (errorMessage) {
      navigate(`/auth/login`);
    }
  }, [errorMessage, navigate]);

  // Handle Edit button click to enable editing
  const handleEditClick = () => {
    setIsEditing(true);
    setValue("email", userData.user.email || "");
    setValue("emailVerification", userData.user.emailVerification || "");
    setValue("firstName", userData.user.firstName || "");
    setValue("lastName", userData.user.lastName || "");
    setValue("aadhar", userData.user.aadhar || "");
    setValue("mobile", userData.user.mobile || "");
  };

  // Handle cancel button click to cancel editing
  const handleCancelClick = () => {
    setIsEditing(false);
  };

  // Handle form submission (API update)
  const onSubmit = async (indata) => {

    const data = {
      firstName: indata.firstName,
      lastName: indata.lastName,
      aadhar: indata.aadhar,
      email: indata.email
    };
    // Check if any of the fields contain '*' in the masked email
    const hasMaskedField = Object.values(data).some(value => value.includes('*'));

    if (hasMaskedField) {
      // Display error message or alert
      alert("தவறான விவரங்களை அனுப்ப முடியாது. மீண்டும் சரிபார்க்கவும்!");
      return;  // Stop form submission if any field has '*' characters
    }

    if (data.aadhar) {
      data.aadhar = data.aadhar.replace(/\s+/g, ''); // Remove all spaces from Aadhaar
    }
    if (
      data.firstName !== userData.user.firstName ||
      data.lastName !== userData.user.lastName ||
      data.aadhar !== userData.user.aadhar
    ) {
      await updateUser(data);
      await getUser(user.email); // Fetch updated user data
    }
    setIsEditing(false);
  };

  const handleToggleFamilyDetails = () => setShowFamilyDetails(!showFamilyDetails);
  const handleToggleDonations = () => setShowDonations(!showDonations);
  const handleToggleMessages = () => setShowMessages(!showMessages);

  useEffect(() => {
    if (user.email && !userData && !userLoading) {
      getUser(user.email);  // Fetch user data if email exists and no data loaded yet
    }
  }, [user.email, userData, userLoading]);

  // Render loading or error states
  if (userLoading) {
    return (
      <>
        <Navbar />
        <div className="general_parent">
          <div className="general_container">
            <div className="general_body">
              <Breadcrumbs /><br />
              <Loading />
            </div>
          </div>
        </div>
        <Footer />
      </>

    );
  }




  if (!userData) {
    return (
      <div className="general_body">
        பயனர் தரவு இல்லை. திசைதிருப்புகிறது...
      </div>
    );
  }
  return (
    <>
      <Helmet>
        <title>பயனர் கணக்கு</title>
        <link rel="canonical" href="/user/profile" />
      </Helmet>
      <Navbar />

      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <Breadcrumbs /><br />
            <h2>வணக்கம், {userData.user.firstName || userData.user.emailMasked}!</h2>
            <br />
            <h4>உங்கள் விவரங்கள்</h4>
            <br />
            <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
              <div className="detail-item">
                <span className="detail-label"><strong>மின்னஞ்சல்:</strong></span>
                <span className="detail-value">{userData.user.emailMasked}{' (சில எழுத்துக்கள் மறைக்கப்பட்டுள்ளது)'} </span>
              </div>

              <div className="detail-item">
                <span className="detail-label"><strong>கைபேசி எண்: </strong></span><span className="detail-value">{userData.user.mobile || ""}
                  {userData.user.mobile && userData.user.mobile.length >= 11
                    ? ` `
                    : ""
                  }
                  {userData.user.mobileVerification === "completed" ? <span style={{ color: 'green' }}>  </span> : <span style={{ color: 'red' }}> (சரிபார்ப்பு நடைபெறுகிறது)</span>}
                </span>
              </div>

              <div className="detail-item">
                <span className="detail-label"><strong>பெயர்:</strong>*</span>
                {isEditing ? (
                  <input
                    type="text"
                    {...register("firstName", {
                      required: "பெயர் அவசியம்",
                      pattern: { value: /^[A-Za-z\u0B80-\u0BFF\s.]*$/, message: "எழுத்துக்கள், இடைவெளிகள் மற்றும் '.' மட்டும் அனுமதிக்கப்படும்" },
                      minLength: { value: 2, message: "குறைந்தது 2 எழுத்துகள் வேண்டும்" },
                      maxLength: { value: 75, message: "பெயர் 75 எழுத்துகளுக்கு அதிகமாக இருக்க முடியாது" },
                    })}
                    defaultValue={userData.user.firstName || ""}
                    className="auth_input"
                    placeholder="உதாரணம்: பொன்னாச்சி"
                    inputMode="text"
                  />
                ) : (
                  <span className="detail-value">{userData.user.firstName || ""}</span>
                )}
                {errors.firstName && <div className="auth_error">{errors.firstName.message}</div>}
              </div>

              <div className="detail-item">
                <span className="detail-label"><strong>தந்தை/கணவர் பெயர்:</strong>*</span>
                {isEditing ? (
                  <input
                    type="text"
                    {...register("lastName", {
                      required: "தந்தை/கணவர் பெயர் அவசியம்",
                      pattern: { value: /^[A-Za-z\u0B80-\u0BFF\s.]*$/, message: "எழுத்துக்கள், இடைவெளிகள் மற்றும் '.' மட்டும் அனுமதிக்கப்படும்" },
                      minLength: { value: 2, message: "குறைந்தது 2 எழுத்துகள் வேண்டும்" },
                      maxLength: { value: 75, message: "பெயர் 75 எழுத்துகளுக்கு அதிகமாக இருக்க முடியாது" },

                    })}
                    defaultValue={userData.user.lastName || ""}
                    className="auth_input"
                    placeholder="உதாரணம்: அம்மன்"
                    inputMode="text"
                  />
                ) : (
                  <span className="detail-value">{userData.user.lastName || ""}</span>
                )}
                {errors.lastName && <div className="auth_error">{errors.lastName.message}</div>}
              </div>

              <div className="detail-item">
                <span className="detail-label"><strong>ஆதார்:</strong>*</span>
                {isEditing ? (
                  <input
                    type="text"
                    {...register("aadhar", {
                      required: "ஆதார் எண் தேவை",
                      pattern: {
                        value: /^(?!00)\d{4}\s?\d{4}\s?\d{4}(?<!00)$/,
                        message: "12-இலக்க எண்ணாக இருக்க வேண்டும்",
                      },
                    })}
                    defaultValue={userData.user.aadhar || ""}
                    className="auth_input"
                    placeholder="உதாரணம்: 1234 5678 9012"
                    autoComplete="off"
                    inputMode="numeric"
                    maxLength="14"
                  />
                ) : (
                  <span className="detail-value">{userData.user.aadhar && userData.user.aadhar.length === 12 ? userData.user.aadhar.replace(/(\d{4})(?=\d)/g, "$1 ") : ""}</span>
                )}
              </div>

              {
                isEditing ? (
                  <>
                    <button type="submit" disabled={isSubmitting}
                      className={`auth_submit ${isSubmitting ? "disabled_btn" : ""}`}
                    >சேமிக்கவும் 💾</button>
                    <br />
                    <button type="button" onClick={handleCancelClick}>ரத்து செய்யவும்</button>
                  </>
                ) : (
                  <button type="button" onClick={handleEditClick}>திருத்தவும்</button>

                )
              }
            </form>



          </div >
        </div >
      </div >
      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            {!showFamilyDetails && (
              <button onClick={handleToggleFamilyDetails} className="section-toggle">
                👨‍👩‍👧‍👦 குடும்ப விவரங்களை காண்க
              </button>
            )}
            {showFamilyDetails && (
              <div className="detail-card">
                <FamilyDetails />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            {!showDonations && (
              <button onClick={handleToggleDonations} className="section-toggle">
                💰 நன்கொடை விவரங்களை காண்க
              </button>
            )}
            {showDonations && (
              <div className="detail-card">
                <DonationDetails />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            {!showMessages && (
              <button onClick={handleToggleMessages} className="section-toggle">
                📧 இன்பாக்ஸில் செய்திகளைக் காட்டு.
              </button>
            )}
            {showMessages && (
              <div className="detail-card">
                <MessagesDetails />
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default UserProfileHome;
